import { Routes } from '@angular/router';
import { BienvenidaPage } from './pages/bienvenida/bienvenida.page';
import { DashboardPage } from './pages/dashboard/dashboard.page';
import { EmpleadosListaPage } from './pages/empleados/lista/empleados-lista.page';
import { EmpleadoFormPage } from './pages/empleados/formulario/empleado-form.page';
import { EmpleadoDetallePage } from './pages/empleados/detalle/empleado-detalle.page';
import { SolicitarVacacionesPage } from './pages/solicitar-vacaciones/solicitar-vacaciones.page';
import { VacacionesListaPage } from './pages/vacaciones/lista/vacaciones-lista.page';
import { AutorizacionesRhPage } from './pages/autorizaciones-rh/autorizaciones-rh.page';
import { MisAutorizacionesPage } from './pages/mis-autorizaciones/mis-autorizaciones.page';
import { CalendarioPage } from './pages/calendario/calendario.page';
import { moduloGuard } from './auth/modulo.guard';

// Matriz de visibilidad por rol (ver CLAUDE.md). El backend valida lo mismo
// vía [Authorize(Roles=...)] e IDOR checks; estos guards son la primera capa.
/*
 * Un guard POR RUTA, con el módulo que esa pantalla representa.
 *
 * Antes eran dos constantes por ROL —`SOLO_ADMIN_RH` y `ADMIN_RH_DIRECTOR`— y
 * siete pantallas repartidas entre ellas. Ahora cada ruta pide lo suyo, que es
 * más fino y además es lo que un administrador puede cambiar desde el portal sin
 * tocar código: quitarle `vacaciones` a un rol deja de requerir un despliegue.
 *
 * El reparto queda IGUAL que antes, comprobado contra los otorgamientos reales:
 * `administrador-rh` tiene los 7 módulos, `director-rh` tiene
 * solicitar-vacaciones, mis-autorizaciones y calendario, y `empleado-rh` sólo
 * solicitar-vacaciones.
 */

export const routes: Routes = [
  // La bienvenida es accesible desde la raíz '/' (default tras login) y desde
  // '/bienvenida' (link directo del menú lateral). Ambas rutas renderizan la
  // misma página — no es redundancia, garantiza que el item del menú quede
  // marcado como activo cuando la URL contiene '/bienvenida'.
  { path: '', component: BienvenidaPage, pathMatch: 'full' },
  { path: 'bienvenida', component: BienvenidaPage },

  { path: 'dashboard', component: DashboardPage, canActivate: [moduloGuard('dashboard')] },

  { path: 'empleados', component: EmpleadosListaPage, canActivate: [moduloGuard('empleados')] },
  {
    path: 'empleados/detalle/:id',
    component: EmpleadoDetallePage,
    // ⚠️ DOS módulos, y es la única excepción de todo el archivo: un Director NO
    // tiene `empleados` —ése es de Administración— pero sí `mis-autorizaciones`,
    // y necesita abrir la ficha de quien le pide vacaciones. Con un solo código
    // se quedaría fuera de una pantalla a la que hoy entra, y la migración
    // habría quitado un permiso sin que nadie lo pidiera.
    canActivate: [moduloGuard('empleados', 'mis-autorizaciones')],
  },
  { path: 'empleados/nuevo', component: EmpleadoFormPage, canActivate: [moduloGuard('empleados')] },
  { path: 'empleados/editar/:id', component: EmpleadoFormPage, canActivate: [moduloGuard('empleados')] },

  { path: 'solicitar-vacaciones', component: SolicitarVacacionesPage },
  { path: 'mis-vacaciones', redirectTo: 'solicitar-vacaciones', pathMatch: 'full' },
  {
    path: 'mis-autorizaciones',
    component: MisAutorizacionesPage,
    canActivate: [moduloGuard('mis-autorizaciones')],
  },

  { path: 'vacaciones', component: VacacionesListaPage, canActivate: [moduloGuard('vacaciones')] },
  { path: 'autorizaciones-rh', component: AutorizacionesRhPage, canActivate: [moduloGuard('autorizaciones-rh')] },
  { path: 'calendario', component: CalendarioPage, canActivate: [moduloGuard('calendario')] },

  { path: '**', redirectTo: '' },
];
